var React = require('react');

function ConciergeBell (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 400v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16zM208 112h16v18.29a224.73 224.73 0 0 1 64 0V112h16a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480 352H32c0-123.71 100.29-224 224-224s224 100.29 224 224z","className":"fa-primary","key":2})]);
}

ConciergeBell.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ConciergeBell;

ConciergeBell.default = ConciergeBell;
